var _ = require('underscore'),
    Backbone = require('backbone');

var ValidatedForm = require('app/backbone/components/forms/ValidatedForm.mixin'),
    Form = require('app/backbone/components/forms/Form.mixin'),
    Modal = require('app/backbone/components/modals/Modal.view'),
    Item = require('app/backbone/models/account/accreditation/Item');

var template = require('./ItemModal');

var ItemModal = Modal.extend({

    template,

    mixins: [
        ValidatedForm,
        Form
    ],

    bindings: {
        '[name=name]': 'name',
        '[name=date_dependable]': 'date_dependable',
        '[name=uses_amounts]': 'uses_amounts'
    },

    options: [
        'itemGroups',
        'width',
        'canCreateAnother',
        'hiddenInputs',
        'disabledInputs'
    ],

    initialize(options) {
        this._super(options);
        // Options
        !_.isUndefined(this.hiddenInputs) || (this.hiddenInputs = []);
        !_.isUndefined(this.disabledInputs) || (this.disabledInputs = []);
        !_.isUndefined(this.canCreateAnother) || (this.canCreateAnother = true);
        !_.isUndefined(this.width) || (this.width = 500);
        // SubViews
        this.inputs = new Backbone.ChildViewContainer();
        this.groups = new Backbone.ChildViewContainer();
    },

    render() {
        this.$el.html(this.template(this.viewModel()));
        this.resolveHandles();
        if(!this.isSyncing) {
            this.unbindModel();
            this.initForm(this.model, this.itemGroups);
            this.bindModel();
            this.renderForm();
        }
        this._super();
        return this.delegateEvents();
    },

    viewModel() {
        return {
            view: {
                isUpdating: this.isUpdating,
                title: this.title,
                canCreateAnother: this.canCreateAnother,
                hiddenInputs: this.hiddenInputs,
                syncingText: this.syncingText,
                isSyncing: this.isSyncing,
                height: this.height
            },
            model: this.model.attributes
        };
    },

    initForm(model, itemGroups) {
        this.disableInputs(this.disabledInputs);

        if(this.isAvailable('name')) this.groups.add(this.initValidationGroup('name', model), 'name');
        if(this.isAvailable('item_group')) this.inputs.add(this.initSingleSelectize('item_group', { model, collection: itemGroups }), 'item_group');
        if(this.isAvailable('date_dependable')) this.groups.add(this.initValidationGroup('date_dependable', model), 'date_dependable');
        if(this.isAvailable('uses_amounts')) this.groups.add(this.initValidationGroup('uses_amounts', model), 'uses_amounts');
    },

    renderForm() {
        this.inputs.call('render');
        this.groups.call('render');
    },

    newModel(attributes, options) {
        return new Item.Model(attributes, options);
    },

    bindModel() {
        this.stickit();
    },

    unbindModel() {
        this.unstickit();
    },

    setSyncing(syncing) {
        if(syncing != this.isSyncing){
            this.isSyncing = syncing;
            this.render();
        }
    },

    onError(model, xhr){
        this.setSyncing(false);
        this.validateResponse(xhr);
    },

    shown() {
        this._super();
        this.focusFirstInput();
    }
});

module.exports = ItemModal;
